import { useCountry } from './useCountry';
import { CountryCode } from '@/utils/countryConfig';

/**
 * Hook that generates country-aware links
 * Automatically adds /uk or /de prefix for UK/DE countries
 * Returns clean paths for RO (no prefix)
 */
export const useCountryLink = () => {
  const { country } = useCountry();
  
  /**
   * Generate a country-aware link
   * @param path - The base path (e.g., '/contact', '/vehicles')
   * @returns Country-prefixed path for UK/DE, clean path for RO
   */
  const getLink = (path: string): string => {
    // Remove leading slash for consistency
    const cleanPath = path.startsWith('/') ? path : `/${path}`;
    
    // RO = no prefix, UK/DE = add prefix
    if (country === 'RO') {
      return cleanPath;
    }
    
    return `/${country.toLowerCase()}${cleanPath}`;
  };
  
  return { getLink, country };
};
